import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsRecordStatus, PmsRecordStatus } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsRecordStatus>
    useData={usePmsRecordStatus}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
